import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { PortalBottomBar, PortalSidebar } from '@/customer/components/portal-nav'

/**
 * Shell for signed-in portal pages. Renders the persistent nav
 * (rail on desktop, bottom bar on mobile) around a centred
 * main-content column.
 *
 * `children` is accepted as an escape hatch so Storybook (and other
 * non-router contexts) can wrap a single page directly, bypassing
 * the outlet.
 */
type PortalLayoutProps = {
  children?: ReactNode
}

export function PortalLayout({ children }: PortalLayoutProps = {}) {
  return (
    <div className="relative min-h-screen bg-background text-foreground">
      <PortalSidebar />
      <main className="flex min-h-screen flex-col px-6 pb-28 pt-6 md:pb-16 md:pl-32 md:pt-10 md:pr-8">
        {children ?? <Outlet />}
      </main>
      <PortalBottomBar />
    </div>
  )
}
